import { Routes } from "@angular/router";
import { authGuard } from "../guards/auth.guard";
import { DeviceSetupComponent } from "src/app/device-onboarding/components/device-setup/device-setup.component";


export const ALL_ROUTES: Routes = [
  {
    path:'',
    redirectTo:'dashboard',
    pathMatch:'full'
  },
    {
    path: 'dashboard',
    loadChildren:()=> import('../../dashboard/dashboard.module').then(m=>m.DashboardModule),
    canActivate:[authGuard]
  },

]
